import type { State } from "@App/state";
import { fromHereCountryCode, type SupportedCountry } from "@App/utils/country";
import { useSelector } from "react-redux";

/**
 * The country the customer is booking in, derived from the searched location.
 *
 * Pure selector — no side effects. Everything that has to *act* on a country change
 * lives in `useSyncCountry`.
 */
export const useCountry = (): SupportedCountry =>
  useSelector((state: State) => fromHereCountryCode(state.orders.place?.countryCode));
